import BasicModalLayout from '@/components/common/modals/BasicModalLayout';
import Modal from '@/components/common/modals/Modal';
import IdvNavigator from '@/components/idv/IdvNavigator';
import { IdvProvider } from '@/components/idv/IdvProvider';
import ModalManager, { useModal } from '@/components/ModalManager';
import { useTrackModalShown } from '@/services/analytics/useTracking';
import { Button } from '../common/Button';

export interface IdvModalProps {
    onComplete: () => void;
    includeInviteStep: boolean;
    title: React.ReactNode;
    subtitle: string;
    consentTitle: string;
    consentSubtitle: string;
}

export const showIdvModal = (props: IdvModalProps) =>
    ModalManager.show(IdvModal, props);

export const hideIdvModal = () => ModalManager.hide(IdvModal);

export const IdvModal = ModalManager.create<IdvModalProps>(
    ({
        onComplete,
        includeInviteStep,
        title,
        subtitle,
        consentTitle,
        consentSubtitle,
    }) => {
        const modal = useModal();

        useTrackModalShown('IDV Modal');

        return (
            <Modal
                size="4xl"
                isOpen={modal.visible}
                onClose={async () => {
                    await showConfirmCloseModal();
                }}
                scrollBehavior="inside"
                isCentered={false}
                isFullScreen
                closeOnOverlayClick={false}
            >
                <IdvProvider
                    onComplete={onComplete}
                    includeInviteStep={includeInviteStep}
                    title={title}
                    subtitle={subtitle}
                    consentTitle={consentTitle}
                    consentSubtitle={consentSubtitle}
                >
                    <IdvNavigator />
                </IdvProvider>
            </Modal>
        );
    }
);

const showConfirmCloseModal = () => ModalManager.show(ConfirmCloseModal);

const ConfirmCloseModal = ModalManager.create(() => {
    const modal = useModal();

    return (
        <Modal size="md" isOpen={modal.visible} onClose={modal.remove}>
            <BasicModalLayout
                title="Are you sure you want to exit identity verification?"
                subtitle="We’ll save your progress and you can continue at anytime. We need to complete identity verification so our partner, BNY Mellon | Pershing, can open up your investment account."
                footer={
                    <>
                        <Button
                            variant="ghost"
                            colorScheme="blackAlpha"
                            onClick={modal.remove}
                            onClickEvent="Exit IDV Cancel Button Clicked"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={() => {
                                modal.remove();
                                hideIdvModal();
                            }}
                            onClickEvent="Exit IDV Confirm Button Clicked"
                        >
                            Close for now
                        </Button>
                    </>
                }
                minH={300}
            />
        </Modal>
    );
});
